<div class="flex flex-col items-center justify-center py-6 text-center">
  <mat-icon svgIcon="mat:error_outline" class="text-red-400 w-8 h-8 mb-2" style="font-size: 32px"></mat-icon>
  <p class="text-sm text-secondary mb-2">Couldn't load this widget</p>
  <button mat-button color="primary" (click)="retry.emit()">
    <mat-icon svgIcon="mat:refresh" class="mr-1"></mat-icon>
    Retry
  </button>
</div>
